<div>
	<h3 class="mb-3">{{ 'users.edit_user_access_functions' | translate }}</h3>
	<p><strong>{{ 'login_register.user_name' | translate }}:</strong> {{ userInfo.first_name }} {{ userInfo.last_name }}</p>

	<div class="col-md-5 my-4 p-4 bg-light rounded shadow-sm">
		<h5 class="mb-3">{{ 'users.access_functions_documentation' | translate }}</h5>
		<select [(ngModel)]="docAccessFunction" class="form-control mb-3">
			<option *ngFor="let key of getKeys(accessFunctions)" [value]="key">
				{{ 'access_func.' + key | translate }}
			</option>
		</select>
		<div *ngIf="docAccessFunction && accessFunctions[docAccessFunction].desc?.length">
			<p *ngFor="let item of accessFunctions[docAccessFunction].desc" class="mb-2">
				<fa-icon [icon]="['far', 'check-square']" size="sm" class="me-2"></fa-icon>
				<span [innerHTML]="item | safe: 'html'"></span>
			</p>
		</div>
	</div>

	<div class="row mt-4">
		<div class="col-md-5">
			<div class="p-3 border rounded shadow-sm">
				<div class="d-flex justify-content-between align-items-center mb-2">
					<h5 class="mb-0">{{ 'users.user_access_functions' | translate }}</h5>
				</div>
				<select multiple class="form-control list-box" size="15" [(ngModel)]="selectedAccessFunctionToRemove">
					<option *ngFor="let key of getKeys(userAccessFunctions)" [value]="key">
						{{ 'access_func.' + key | translate }}
					</option>
				</select>
			</div>
		</div>
	
		<div class="col-md-2 d-flex flex-column justify-content-center align-items-center gap-2">
			<button class="btn btn-outline-primary w-100 mb-2" (click)="assignAllAccessFunctionToUser()"><i class="fa fa-backward"></i></button>
			<button class="btn btn-outline-secondary w-100 mb-2" [disabled]="!selectedAccessFunctionToAdd.length" (click)="addSelectedAccessFunctionToUser()"><i class="fa fa-chevron-left"></i></button>
			<button class="btn btn-outline-secondary w-100 mb-2" [disabled]="!selectedAccessFunctionToRemove.length" (click)="removeSelectedAccessFunctionFromUser()"><i class="fa fa-chevron-right"></i></button>
			<button class="btn btn-outline-danger w-100 mb-2" (click)="removeAllUserAccessFunctions()"><i class="fa fa-forward"></i></button>
		</div>
	
		<div class="col-md-5">
			<div class="p-3 border rounded shadow-sm">
				<div class="d-flex justify-content-between align-items-center mb-2">
					<h5 class="mb-0">{{ 'users.other_access_functions' | translate }}</h5>
				</div>
				<select multiple class="form-control list-box" size="15" [(ngModel)]="selectedAccessFunctionToAdd">
					<option *ngFor="let item of accessOptionsToAdd" [value]="item.value">
						{{ item.label }}
					</option>
				</select>
			</div>
		</div>
	</div>
	<div class="mt-3">
		<button class="btn btn-info mr-3" (click)="checkUserAccessFunctionBeforeUpdate()">{{ 'g.save' | translate }}</button>
		<button class="btn btn-secondary me-2" (click)="goBack()">{{ 'g.cancel' | translate }}</button>
	</div>
</div>

<app-modal #confirmUpdateUserAccessFunction title="{{'g.confirm_action' | translate}}" closeBtnText="{{'g.no' | translate}}" confirmBtnText="{{'g.yes' | translate}}">
	<div>
		<p>{{ 'access_func.confirm_user_has_login_disable_message' | translate }}</p>
	</div>
</app-modal>